import { render } from "./StockRemainder.vue?vue&type=template&id=34ce4aab&scoped=true"
import script from "./StockRemainder.vue?vue&type=script&lang=js"
export * from "./StockRemainder.vue?vue&type=script&lang=js"

import "./StockRemainder.vue?vue&type=style&index=0&id=34ce4aab&scoped=true&lang=css"
import "./StockRemainder.vue?vue&type=style&index=1&id=34ce4aab&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34ce4aab"]])

export default __exports__